let bannerElement = false;

const hideMessage = () => {
	if (!bannerElement) return;
	bannerElement.classList.remove('is-showing');
	bannerElement.setAttribute('aria-live', 'off');
};

const showMessage = (message, type = 'error', instant = 3000) => {
	bannerElement = document.querySelector('[data-banner]');
	const messageElement = bannerElement.querySelector('[data-message');
	const dismissElement = bannerElement.querySelector('[data-dismiss');
	if (!messageElement) return;

	bannerElement.dataset.banner = type;
	messageElement.innerHTML = message;

	setTimeout(() => {
		bannerElement.classList.add('is-showing');
		bannerElement.setAttribute('aria-live', 'assertive');
	}, instant);

	if (dismissElement) dismissElement.addEventListener('click', hideMessage);
};

export { showMessage, hideMessage };
